<div class="container-fluid d-flex flex-column h-100">
  <div class="row">
    <div class="col">
      <h2>
        Contracts
        @if (Vendor && Vendor.legalName) {
          <span>{{ Vendor.legalName ? ' - ' + Vendor.legalName : '' }}</span>
        }
      </h2>
    </div>
  </div>
  <div class="row flex-grow-1 mb-2">
    <div class="col">
      @if (suppliedGridQueryData) {
        <app-contracts-grid
          [suppliedQueryData]="suppliedGridQueryData"
          [gridName]="'ClientVendorContracts'"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          (rowClick)="action({ action: 'view', rowData: $event.data })"
          (actionEvent)="action($event)"
        ></app-contracts-grid>
      }
    </div>
  </div>
</div>
